import { lazy } from 'react';

export const Chat = lazy(() => import('./Chat'));
export const Analytics = lazy(() => import('./Analytics'));
export const Tasks = lazy(() => import('./Tasks'));
export const Contacts = lazy(() => import('./Contacts'));
export const Campaigns = lazy(() => import('./Campaigns'));
export const Datasource = lazy(() => import('./Datasource'));
export const ContactsImport = lazy(() => import('./ContactsImport'));
export const CampaignWebhooks = lazy(() => import('./CampaignWebhooks'));
export const CampaignCallerAgents = lazy(
  () => import('./CampaignCallerAgents')
);
export const GeneralMonitoring = lazy(() => import('./GeneralMonitoring'));
export const CampaignMonitoring = lazy(() => import('./CampaignMonitoring'));
export const MessagesForContact = lazy(() => import('./MessagesForContact'));
export const PromptsForCampaign = lazy(() => import('./PromptsForCampaign'));
export const OrganizationSecrets = lazy(() => import('./OrganizationSecrets'));
export const DialerScheduleSettings = lazy(
  () => import('./DialerScheduleSettings')
);
export const ContactStateSettings = lazy(
  () => import('./ContactStateSettings')
);
